import { createContext, useContext, useMemo, useReducer } from 'react';

import { type EstimationState, type IEstimationsActions, initEstimationState } from './model';
import { reducer } from './reducer';
import { useActions } from './useActions';

type IEstimationContext = {
  state: EstimationState;
  actions: IEstimationsActions;
};

const EstimationContext = createContext<IEstimationContext>({} as IEstimationContext);

export const EstimationProvider: FCC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initEstimationState);
  const actions = useActions(dispatch);

  const value = useMemo<IEstimationContext>(
    () => ({
      state,
      actions: actions as IEstimationsActions,
    }),
    [state, actions],
  );

  return <EstimationContext.Provider value={value}>{children}</EstimationContext.Provider>;
};

export const useEstimation = () => useContext(EstimationContext);
